import React from 'react'
import {Box, BoxProps} from '../../vanilla'
import {shimmerGradient} from './skeleton-block.css'

export type SkeletonBlockProps = Omit<BoxProps<'div'>, 'as' | 'children'>

export const SkeletonBlock = (props: SkeletonBlockProps) => (
    <Box
        backgroundColor="gray50"
        borderRadius="medium"
        position="relative"
        overflow="hidden"
        {...props}
    >
        <span className={shimmerGradient} aria-hidden="true" />
    </Box>
)
